import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftSharepoint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 10.0425,
				y: 4.29785,
				width: 27.9574,
				height: 32.1702,
				fill: "url(#pattern0_6369_1969)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .2,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M36.5321 21.0692C36.5279 23.0937 35.7207 25.0338 34.2877 26.4638C32.8547 27.8938 30.9129 28.6969 28.8885 28.6969C28.4176 28.6947 27.9478 28.652 27.4842 28.5692C27.3506 29.6464 26.9404 30.6706 26.2936 31.5421C25.6468 32.4137 24.7854 33.103 23.7931 33.543C22.8009 33.9829 21.7117 34.1585 20.6315 34.0526C19.5513 33.9467 18.5169 33.563 17.629 32.9388C16.7411 32.3146 16.0298 31.4712 15.5646 30.4906C15.0993 29.51 14.8958 28.4257 14.9738 27.3431C15.0519 26.2605 15.4089 25.2166 16.0101 24.3129C16.6112 23.4093 17.4361 22.6766 18.4044 22.1863C16.7508 21.8192 15.2347 20.9922 14.0309 19.8006C12.8272 18.609 11.9848 17.1014 11.6009 15.4516C11.2171 13.8019 11.3074 12.0772 11.8615 10.4766C12.4157 8.87598 13.411 7.46462 14.7327 6.40533C16.0544 5.34603 17.6487 4.68195 19.3315 4.4897C21.0144 4.29745 22.7173 4.58485 24.2439 5.31876C25.7705 6.05267 27.0584 7.20318 27.9593 8.63757C28.8601 10.072 29.3371 11.7318 29.3353 13.4256C31.2827 13.5435 33.1118 14.4001 34.4492 15.8205C35.7866 17.241 36.5316 19.1182 36.5321 21.0692Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .12,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 10.729,
				y: 3.83496,
				width: 26.8085,
				height: 31.4043,
				fill: "url(#pattern1_6369_1969)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .12,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M36.5321 21.0692C36.5279 23.0937 35.7207 25.0338 34.2877 26.4638C32.8547 27.8938 30.9129 28.6969 28.8885 28.6969C28.4176 28.6947 27.9478 28.652 27.4842 28.5692C27.3506 29.6464 26.9404 30.6706 26.2936 31.5421C25.6468 32.4137 24.7854 33.103 23.7931 33.543C22.8009 33.9829 21.7117 34.1585 20.6315 34.0526C19.5513 33.9467 18.5169 33.563 17.629 32.9388C16.7411 32.3146 16.0298 31.4712 15.5646 30.4906C15.0993 29.51 14.8958 28.4257 14.9738 27.3431C15.0519 26.2605 15.4089 25.2166 16.0101 24.3129C16.6112 23.4093 17.4361 22.6766 18.4044 22.1863C16.7508 21.8192 15.2347 20.9922 14.0309 19.8006C12.8272 18.609 11.9848 17.1014 11.6009 15.4516C11.2171 13.8019 11.3074 12.0772 11.8615 10.4766C12.4157 8.87598 13.411 7.46462 14.7327 6.40533C16.0544 5.34603 17.6487 4.68195 19.3315 4.4897C21.0144 4.29745 22.7173 4.58485 24.2439 5.31876C25.7705 6.05267 27.0584 7.20318 27.9593 8.63757C28.8601 10.072 29.3371 11.7318 29.3353 13.4256C31.2827 13.5435 33.1118 14.4001 34.4492 15.8205C35.7866 17.241 36.5316 19.1182 36.5321 21.0692Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3512 22.4097C25.313 22.4097 29.3353 18.3874 29.3353 13.4257C29.3353 8.46394 25.313 4.44165 20.3512 4.44165C15.3895 4.44165 11.3672 8.46394 11.3672 13.4257C11.3672 18.3874 15.3895 22.4097 20.3512 22.4097Z",
			fill: "#036C70"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.8882 28.7128C33.1097 28.7128 36.5319 25.2906 36.5319 21.0692C36.5319 16.8477 33.1097 13.4255 28.8882 13.4255C24.6668 13.4255 21.2446 16.8477 21.2446 21.0692C21.2446 25.2906 24.6668 28.7128 28.8882 28.7128Z",
			fill: "#1A9BA1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2448 34.0906C24.7171 34.0906 27.532 31.2757 27.532 27.8033C27.532 24.331 24.7171 21.5161 21.2448 21.5161C17.7724 21.5161 14.9575 24.331 14.9575 27.8033C14.9575 31.2757 17.7724 34.0906 21.2448 34.0906Z",
			fill: "#37C6D0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M36.5321 21.0692C36.5279 23.0937 35.7207 25.0338 34.2877 26.4638C32.8547 27.8938 30.9129 28.6969 28.8885 28.6969C28.4176 28.6947 27.9478 28.652 27.4842 28.5692C27.3506 29.6464 26.9404 30.6706 26.2936 31.5421C25.6468 32.4137 24.7854 33.103 23.7931 33.543C22.8009 33.9829 21.7117 34.1585 20.6315 34.0526C19.5513 33.9467 18.5169 33.563 17.629 32.9388C16.7411 32.3146 16.0298 31.4712 15.5646 30.4906C15.0993 29.51 14.8958 28.4257 14.9738 27.3431C15.0519 26.2605 15.4089 25.2166 16.0101 24.3129C16.6112 23.4093 17.4361 22.6766 18.4044 22.1863C16.7508 21.8192 15.2347 20.9922 14.0309 19.8006C12.8272 18.609 11.9848 17.1014 11.6009 15.4516C11.2171 13.8019 11.3074 12.0772 11.8615 10.4766C12.4157 8.87598 13.411 7.46462 14.7327 6.40533C16.0544 5.34603 17.6487 4.68195 19.3315 4.4897C21.0144 4.29745 22.7173 4.58485 24.2439 5.31876C25.7705 6.05267 27.0584 7.20318 27.9593 8.63757C28.8601 10.072 29.3371 11.7318 29.3353 13.4256C31.2827 13.5435 33.1118 14.4001 34.4492 15.8205C35.7866 17.241 36.5316 19.1182 36.5321 21.0692Z",
			fill: "url(#paint0_linear_6369_1969)",
			style: { mixBlendMode: "overlay" }
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .48,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 2,
				y: 9.65967,
				width: 22.5957,
				height: 22.5957,
				fill: "url(#pattern2_6369_1969)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .48,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M19.8879 11.6226H6.41986C5.67075 11.6226 5.06348 12.2298 5.06348 12.9789V26.447C5.06348 27.1961 5.67075 27.8034 6.41986 27.8034H19.8879C20.6371 27.8034 21.2443 27.1961 21.2443 26.447V12.9789C21.2443 12.2298 20.6371 11.6226 19.8879 11.6226Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .24,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 4.64941,
				y: 11.1597,
				width: 17.234,
				height: 17.234,
				fill: "url(#pattern3_6369_1969)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .24,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M19.8879 11.6226H6.41986C5.67075 11.6226 5.06348 12.2298 5.06348 12.9789V26.447C5.06348 27.1961 5.67075 27.8034 6.41986 27.8034H19.8879C20.6371 27.8034 21.2443 27.1961 21.2443 26.447V12.9789C21.2443 12.2298 20.6371 11.6226 19.8879 11.6226Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8879 11.6226H6.41986C5.67075 11.6226 5.06348 12.2298 5.06348 12.9789V26.447C5.06348 27.1961 5.67075 27.8034 6.41986 27.8034H19.8879C20.6371 27.8034 21.2443 27.1961 21.2443 26.447V12.9789C21.2443 12.2298 20.6371 11.6226 19.8879 11.6226Z",
			fill: "#038387"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "soft-light" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .5,
				d: "M19.8879 11.6226H6.41986C5.67075 11.6226 5.06348 12.2298 5.06348 12.9789V26.447C5.06348 27.1961 5.67075 27.8034 6.41986 27.8034H19.8879C20.6371 27.8034 21.2443 27.1961 21.2443 26.447V12.9789C21.2443 12.2298 20.6371 11.6226 19.8879 11.6226Z",
				fill: "url(#paint1_linear_6369_1969)",
				style: { mixBlendMode: "soft-light" }
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1119 19.5534C10.8146 19.3662 10.568 19.1086 10.3939 18.8034C10.2162 18.4814 10.128 18.1177 10.1385 17.7502C10.1249 17.262 10.2894 16.7855 10.6013 16.4098C10.936 16.0322 11.3658 15.7511 11.846 15.5959C12.391 15.4129 12.9625 15.3213 13.5375 15.3246C14.2952 15.2975 15.0517 15.4056 15.7715 15.6438V17.2395C15.4594 17.051 15.1204 16.9111 14.7662 16.8247C14.3799 16.7288 13.9833 16.6806 13.5853 16.681C13.166 16.6625 12.7488 16.7504 12.3726 16.9364C12.2299 16.9986 12.1085 17.1013 12.0234 17.2318C11.9383 17.3622 11.8933 17.5147 11.8939 17.6704C11.8913 17.8586 11.9597 18.0409 12.0853 18.181C12.2404 18.353 12.4309 18.4891 12.6439 18.58C12.8673 18.6917 13.2183 18.8512 13.6811 19.0268H13.8247C14.2737 19.2007 14.7062 19.4143 15.1173 19.6651C15.4335 19.8582 15.6967 20.1269 15.8832 20.447C16.0865 20.8006 16.1861 21.2043 16.1704 21.6119C16.194 22.1183 16.0355 22.6164 15.7236 23.0161C15.4249 23.3903 15.0182 23.6633 14.5587 23.7981C14.0446 23.9709 13.5054 24.0572 12.963 24.0534C12.455 24.0532 11.9479 24.0105 11.447 23.9257C11.0255 23.8557 10.6133 23.7379 10.2183 23.5746V21.947C10.5932 22.219 11.0152 22.4192 11.463 22.5374C11.9075 22.6765 12.3696 22.7518 12.8353 22.7608C13.2622 22.7865 13.6877 22.6925 14.0641 22.4895C14.1949 22.4181 14.3031 22.3115 14.3764 22.1818C14.4497 22.0521 14.4853 21.9044 14.479 21.7555C14.4779 21.543 14.3983 21.3384 14.2556 21.181C14.0602 21.0012 13.8398 20.8507 13.6013 20.7342C13.33 20.6066 12.9311 20.4151 12.3885 20.1917C11.9409 20.0263 11.5128 19.8123 11.1119 19.5534Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern0_6369_1969",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image0_6369_1969",
					transform: "scale(0.0135135 0.0117647)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern1_6369_1969",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image1_6369_1969",
					transform: "scale(0.0140845 0.0120482)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern2_6369_1969",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image2_6369_1969",
					transform: "scale(0.0166667)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern3_6369_1969",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image3_6369_1969",
					transform: "scale(0.0217391)"
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_6369_1969",
				x1: 15.197,
				y1: 6.00541,
				x2: 29.3034,
				y2: 30.4203,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						stopColor: "white",
						stopOpacity: .5
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2,
						stopColor: "#B4B4B4",
						stopOpacity: .56
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .44,
						stopColor: "#666666",
						stopOpacity: .62
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .66,
						stopColor: "#2E2E2E",
						stopOpacity: .66
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .86,
						stopColor: "#0C0C0C",
						stopOpacity: .69
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopOpacity: .7
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_6369_1969",
				x1: 7.87199,
				y1: 10.5694,
				x2: 18.4358,
				y2: 28.8566,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: .7
				})]
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image0_6369_1969",
				width: 74,
				height: 85,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,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"
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image1_6369_1969",
				width: 71,
				height: 83,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAABTCAYAAADN9xqSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD/0lEQVR4Xu2crXbbMBhAr3pGDAYGBluYPEQHC0b2GKWjJYMjo6F9i9KN9gEGU5i8QwI1YH2u4tiW/yRb0u45Ojk9sY/S60+y9Em20lrzn2Y+uA4Yi1KqAG6BovbVGThqrc/XZ60LNUfktIi4Ax7Np80BeDafwiqFTZJjSdlyLaIzcsynIML2rEjSKDkNUrY0i+iLCNuzIkmD5HiQUmdVknrLMWLuge/ML6WOLWkHvC4iSGvtLJQSHoDfwAnQgcrJ1PkAFK7fOXdxH7CcmMUFdX+5vJhFBcUgRkpwQbGIkRJUUJucDfDCusRICSbohhrmlr01xdetegr2kOLWcewkruRQVviI54onUl1AczG9cCEngqix8X4R65HjvcIZ8R49lZzIokbwejHtyPFakScKyjSJl4tpy/FaUYw03a1iowDufPQ7N1D1N7FGjbfuQCLHWwUB8HZhRY63CmImhT7HG97WrQJTABullPw9y1JPKnJugZ+8L/ccgGel1IEJolKRU1CmWYQN5Uj/zLuowSsZqcipY8sSUXtgp5TqvZKRqhwbESVLSbu+USRyJPw2pHs7lyTZHX2jyKRFC+CbOcmVpkyh9Eq13gAYe9Kz54BE0RNw3zYvy3kQ6MxF23Jyix5wZROlfZFfvyOltf+pIsf0O3tTcouexuZV73OOlPtijuRFY1biQk7G0QMNGcWmu1Wu0XOV8LuSk3H0XDWttnHOEbPdjAwFVU2rbehsDlzjNhSf5US5u2TTuMtCMM3rFfhFPhF00bQ6pw+ZCqpwzq1qgv4Ab2QiqVeyS2t9Vkq9Us69tpSjyXvSzf0APeVAFUFvSil5biHEZu1F6S1HaIgieSCkIDFRg+XAVRTtgU/AF8poqj9CFC3ODrkLI+kIfAS+Ap+7z1g9lzmttkFgn0J6A8U9ZU6r6BwEurCeonkinTvXGTiYFjFOTspisMdwrqbT0pzWvMN9bLloUqOaVaS7Tl1UaRppUjCuWcW8C6yNxgTfIDk5RQ0MlEN6USOT6h0NaeGhchqz9JFykY6pRw0Ml5MKTjGQp5xeYiA/Ob3FwMhZeYTIBHnQQ/ypy7GlDH79Q2pyRIb88wdGSBFilFMXYCMyDvaxQ6UIMco5Aj8oV0HqTJJRJ0Y5Z+BNa/3XdeBUht7Kr3MeYQla/1A5S29PCVr/IDl62e0prbNnXwySYwh69SyC1ztYzkLREzxqYIQcQ8jNTTIfasy5eMWVTO9IsodYs+r1jIKv4jyg82S/ghYVo/VEOVp7EXSi7F9elhSjte7/nsAuZnqH4KQZtA9mkQOt7yl1bUuxJ5GTZtA+mE2OUHvDbdubbQV7Fj3rpHEOZpdjUxPVxOqE2HiVEzv/AEmcSZvmU6xEAAAAAElFTkSuQmCC"
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image2_6369_1969",
				width: 60,
				height: 60,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAC4jAAAuIwF4pT92AAADoUlEQVRoQ+2b61LbMBBGj3IhoUAphbbT93+6Ti8DoZCEXNwfq43WshyHUizi+pvZ8SWO2ONd2WH82RVFwf+kUdMBKTnnXNMxr63iLyvl9n3PgFnA7LBGhV0echJqgT2sAwZ+add3hyW++tqykBpbu70PPAnsnBsgcANgGIU9AbmANTaJ2ALbOujKHDawI2AMnJgY+dBjoF1ohdgicGtgBTyZWAE455LQJWDfxgo7AabAO+AMOPX7TqhWui3ZFl4jgHPg0YTz+5PQO+Bozo4RwAvg0sd7BH7qPx/S3ny2SWt1Vwjsb2AG3CI56fE2dopbWqt7gsBdAp+AG+Cj3z6lXOU2pQBrYAk8AHfATwJLaT4755ytsgXWCg+R1j0DPiDAX4HPwBVwTpjPOVpa23kJ3AO/kHwx+5dIW6/jAVIVHiJAp0gbXwNfEOhrpM0nhJbOAbwBFkgrT/1nWvF7v9QO1FsWUAXWCo+Rgc4Q6CukrW/ID6wtvSBUdoG09jlSqNQ1BvDA5oKlFy2tsl6lz31c8DaAN0h+IJW9INxJdLol80v9lrbQ9l48iSI3MMg8nRJyGpOAtReuVEvr0oLbGJn1NmFVOh9tLiOzrj+KkrnVVTgVdiAbOVSXlwVN5nfofTT+Yi5QVV1RiNYragLODfbP1QR8bGosUNeAG9UDd109cNfVA3ddPXDX1QN3XT1w19UDd109cNfVA3ddPXDX1QMfuWrdO6om4MYBjk1NwKoYPPeJiD0c1stR8XVY1VkP4wHsvvgPtK04hy3hKb992p/MMQauGyxlAIP2nyBqXprD2ix13Z6AilIVtoOq8UvNX0vCk/ccz4dtbgsTamRZEcB3Fa64eIqiKLyPVKuqsEs/4IMPNZA8kRdYPR4zH2pkmRPcOyVola2wbeMVAvvoB7tF/BMgf0h9WjmAYxfPD8S6dIeY1OZI/gpcUmoOq8tNYa0Pao6YR9QlA+1CK3Ds0/qGmNNmSN5PhPm8t8J69rS6d5TdMrcE66G1F7Ql29KxE+87kp8FPqjCatp8RAbAb88QC9OE4KhVvTa4TXyf1zKucMU7vQP2F664pUFOgFZbYXNYlqB8nalz0y6Q/JO3ppJB3BjU1I1nPVq6bWFzAEOzX3pDjUm84oiPbMSxL2tAmLttw6oKE6kfRHsd8XWvAMR2oEG0jVm2rcIsbYvvtp/9zsPuw+pbLbkg62ThX/ZWS53ewjtLcBhcSs8GPnYd+v9wZ/QHTbqvfA0XAmsAAAAASUVORK5CYII="
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image3_6369_1969",
				width: 46,
				height: 46,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwUlEQVRoQ+3ZsQkCMRyF8S8iZAm765zAzr0cwJ3sLG8BN8gQSfW3CIdeZ/VM4P0gTSDwcXDVSxFBSikDJyAzpgaUiGjbRaLHXoAbPX5EBbgD63f8AjyACsSgpwJP4ArkiADgDLx+ePzvU+kfeIkIDsxj9x/OFL7jcDWHqzlczeFqDldzuJrD1Ryu5nA1h6s5XM3hag5Xc7iaw9UcruZwNYcLNPre2aCH7y4G1YCVPtIWgCOf1RYmWpbTtFv+Ni/P5g1xTodLg4W2uAAAAABJRU5ErkJggg=="
			})
		] })
	]
});
export default SvgMicrosoftSharepoint;
